import { VenueSpaceSummary } from "../types/venue";

/** Normalizes for comparison: trims, lowercases, and collapses internal whitespace/&-variants
 * so minor LangGraph vs. taxonomy formatting differences (e.g. "Entrances & Exits" vs.
 * "entrances and exits") still match. */
function normalize(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, " ");
}

/**
 * Finds the AI-generated summary for a space, matching on category (catName) and
 * subcategory (the space card's title). Returns null when there's no summary for
 * this venue, or none matching this specific space.
 */
export function getVenueSpaceSummary(
  summaries: VenueSpaceSummary[] | null | undefined,
  category: string | undefined,
  subcategory: string | undefined,
): string | null {
  if (!summaries || summaries.length === 0 || !category || !subcategory) {
    return null;
  }

  const normalizedCategory = normalize(category);
  const normalizedSubcategory = normalize(subcategory);

  const match = summaries.find(
    (item) =>
      normalize(item.category) === normalizedCategory &&
      normalize(item.subcategory) === normalizedSubcategory,
  );

  return match?.summary?.trim() || null;
}
